import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { RedirectCommand, Router } from '@angular/router';
import { BasesRoute } from '../enums/bases-route';
import { BaseHelper } from '../helpers/base.helper';

export const baseCardResolver: ResolveFn<void> = (
  route: ActivatedRouteSnapshot,
) => {
  const baseHelper = inject(BaseHelper);
  const router = inject(Router);

  const uuid = route.paramMap.get('uuid')!;
  baseHelper.openModal(uuid);

  const urlTree = router.parseUrl(BasesRoute.BASES_LIST);
  return new RedirectCommand(urlTree, { replaceUrl: true });
};
